import type { Lesson } from '../schema.js';

export const CROWNING_LESSONS: Lesson[] = [
  {
    id: 'crowning',
    slug: 'crowning-reach-the-last-row',
    title: 'Crowning — reach the last row!',
    audienceLevel: 'beginner',
    concepts: ['crowning'],
    steps: [
      {
        kind: 'explain',
        title: 'What is crowning?',
        body: 'In checkers, if one of your checkers marches all the way to the last row on the other side of the board, it gets CROWNED — it becomes a king! You can see the gold crown row glowing on the board. Getting crowned is a big deal, so keep moving a checker forward whenever it is safe.',
        narration: 'March a checker to the last row and it becomes a king!',
      },
      {
        kind: 'quiz',
        title: 'What does a checker become?',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'What happens when one of your checkers reaches the last row on the far side?',
            choices: [
              'It disappears from the board',
              'It gets crowned and becomes a king',
              'It turns into two checkers',
            ],
            correct: 1,
          },
          {
            prompt: 'Why is it good to get crowned?',
            choices: [
              'Kings can move more ways than ordinary checkers',
              'Crowning ends the game right away',
              'Nothing really changes',
            ],
            correct: 0,
          },
        ],
      },
    ],
  },
  {
    id: 'crowning-king-power',
    slug: 'crowning-king-power',
    title: 'Kings fly both ways',
    audienceLevel: 'beginner',
    concepts: ['crowning'],
    steps: [
      {
        kind: 'explain',
        title: 'A king is the strongest checker',
        body: 'An ordinary checker only ever steps forward. A king moves and captures in ALL four diagonal directions — forward and backward — and it can slide a long way in one go. That is why a king is worth about three ordinary checkers!',
        narration: 'Kings move both ways and can fly across the board.',
      },
      {
        kind: 'quiz',
        title: 'How do kings move?',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'Which directions can a king move in?',
            choices: [
              'Only forward, like a checker',
              'Only backward',
              'All four diagonal directions',
            ],
            correct: 2,
          },
          {
            prompt: 'About how many ordinary checkers is a king worth?',
            choices: ['One', 'Two', 'Three'],
            correct: 2,
          },
        ],
      },
    ],
  },
  {
    id: 'crowning-back-row',
    slug: 'crowning-guard-the-back-row',
    title: 'Guard your back row',
    audienceLevel: 'beginner',
    concepts: ['crowning'],
    steps: [
      {
        kind: 'explain',
        title: 'Your back row is the front door',
        body: 'The checkers on your back row stop the enemy from reaching your last row and getting crowned for free. If you move them out too early, an enemy checker can sneak past and crown itself! Just remember: do not keep them home forever — sometimes moving them out is exactly the right move.',
        narration: 'Keep your back row guarded so the enemy cannot crown for free.',
      },
      {
        kind: 'quiz',
        title: 'Why guard the back row?',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'What can happen if you empty your back row too early?',
            choices: [
              'Nothing — it is always safe',
              'An enemy checker can sneak through and get crowned',
              'Your checkers move slower',
            ],
            correct: 1,
          },
        ],
      },
    ],
  },
];
